const formatLoadFile = 'image/jpeg,image/png,image/webp'

interface LoadFile {
  accept?: string
  onError?: () => void
  onLoadFile?: (file: File) => void
}

export const onLoadFileInput = ({ accept, onError, onLoadFile }: LoadFile) => {
  const input = document.createElement('input')

  input.type = 'file'
  input.accept = accept || formatLoadFile

  input.onchange = (e) => {
    const file = (e.target as HTMLInputElement)?.files?.[0]

    if (!file) {
      onError?.()

      return
    }

    onLoadFile?.(file)

    input.remove()
  }

  input.click()
}
